module.exports = require('./helpers/bundle-url').getBundleURL('dUBYF') + "logo-dark.eefe0b7f.svg";